module.exports = __webpack_public_path__ + "static/media/certificate-icon.42af3de4.png";